

















































import { IOrder } from "@/@types/orders/new-order";
import { IReason } from "@/@types/orders/reason";
import { Component, Prop, Vue } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal } })
export default class ChangeOrderStatus extends Vue {
  @Prop({ type: Object, default: null }) order!: IOrder;
  @Prop({ type: Array, default: () => [] }) reasons!: Array<IReason>;

  reason_id = "";

  get reason(): IReason | null {
    const reason = this.reasons.find((el) => el._id == this.reason_id);
    return reason ? reason : null;
  }
}
